import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  constructor(private http: HttpClient) { }

  //Observable for downloading a file by URL.
  downloadFile$(url: string): Observable<HttpResponse<Blob>> {
    return this.http.get(url, { responseType: 'blob', observe: 'response' })
      .pipe(tap((resp) => {
        const contentDisposition = resp.headers.get('content-disposition');
        const filenameHeader = contentDisposition.split(';')[1];
        const filename = filenameHeader.split('=')[1].replace(/\"/g, "");

        this.download(resp.body, filename);
      }));
  }

  //Downlaod report file by URL.
  downloadFile(url: string): void {
    this.downloadFile$(url).subscribe({
      error: error => console.log('Error downloading the file.', error),
      complete: () => console.info('OK')
    });
  }

  private download(data: any, filename: string): void {
    const blob = new Blob([data], { type: 'type: "octet/stream' });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    link.click();

  }
}
